import { Button, Container, Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

import FlexRow from "../../../../components/Flex/FlexRow";

import privacyNotice from "./policy.md?raw";

const Policy = () => {
	const { t } = useTranslation();
	return (
		<Segment padded>
			<Container text>
				<ReactMarkdown>{privacyNotice}</ReactMarkdown>

				<FlexRow style={{ marginTop: "2em", gap: "1em" }}>
					<a href="/policy.pdf">
						<Button primary icon="file pdf" content={t("downloadPdfBtn")} />
					</a>
					<Link to="/">
						<Button color="green" icon="mail forward" content={t("toAstrid", "To Astrid")} />
					</Link>
				</FlexRow>
			</Container>
		</Segment>
	);
};
export default Policy;
